import React, { useState, useEffect, useContext, memo } from 'react';
import './Transactions.css';
import { useMediaQuery } from '@react-hook/media-query';
import { useNavigate } from 'react-router-dom';
import { InboxOutlined } from '@ant-design/icons';
import { Button, Spin, Pagination } from 'antd';
import { AuthContext } from '../context/AuthContext';
import config from '../config.json';
import axios from 'axios';
import moment from 'moment';

function TransactionsComponent() {
  console.log("TransactionsComponent rendered");
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalItems: 0, itemsPerPage: 10 });
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { whatsappNumber, active_accesskey } = useContext(AuthContext).user || {};
  const { user } = useContext(AuthContext);
  const apiUrl = config.API_URL;
  const [hasFetched, setHasFetched] = useState(false);

  const formatPhoneNumber = (phone) => {
    if (phone.startsWith('211') && phone.length === 12) {
      return `+${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6, 9)} ${phone.slice(9)}`;
    }
    return phone;
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US').format(amount);
  };

  const fetchTransactions = async (page = 1) => {
    if (user && user !== null && whatsappNumber && active_accesskey) {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/request/getTransactions`, {
          params: {
            phoneNo: whatsappNumber,
            active_accesskey: active_accesskey,
            page: page,
            limit: 10
          }
        });

        if (response.data.status) {
          const formattedTransactions = response.data.data.transactions.map(transaction => ({
            id: transaction.id,
            date: transaction.time,
            amount: transaction.amount,
            phoneNumber: transaction.phoneNo,
            status: transaction.status,
            refunded: transaction.refunded
          }));
          setTransactions(formattedTransactions);
          setPagination(response.data.data.pagination);
        } else {
          console.error("Error fetching transactions:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    console.log("useEffect triggered", user, apiUrl);
    if (!hasFetched && user && whatsappNumber && active_accesskey) {
      setHasFetched(true);
      fetchTransactions(1);
    }
  }, [user, whatsappNumber, active_accesskey, hasFetched]);

  const handleAddTransaction = () => {
    navigate('/airtime');
  };

  const handlePageChange = (page) => {
    fetchTransactions(page);
  };

  return (
    <div className="transactions-container">
      <h1>Transactions</h1>
      <p className="transactions-note">Note: Transactions are paginated, showing {pagination.itemsPerPage} per page.</p>
      {loading ? (
        <div className="loading-indicator">
          <Spin size="large" />
        </div>
      ) : transactions.length === 0 ? (
        <div className="empty-transactions">
          <InboxOutlined style={{ fontSize: '50px', marginBottom: '10px' }} />
          <p>No transactions found.</p>
          <Button type="primary" ghost onClick={handleAddTransaction}>Add Transaction</Button>
        </div>
      ) : (
        <>
                {isMobile ? (
                   transactions.map((transaction, index) => {
                     const remark = transaction.status === 'Completed' ? 'Successful' : transaction.status === 'Failed' ? (transaction.refunded ? 'Refunded' : 'Failed') : '';
                     return (
                       <div key={transaction.id} className="transaction-card">
                         <h3>{moment(transaction.date).format('YYYY-MM-DD hh:mm a')}</h3>
                         <p><strong>Amount:</strong> {formatAmount(transaction.amount)} SSP</p>
                         <p><strong>Phone Number:</strong> {formatPhoneNumber(transaction.phoneNumber)}</p>
                         <p><strong>Status:</strong> <strong style={{ color: transaction.status === 'Completed' ? 'green' : transaction.status === 'Active' ? 'blue' : 'red' }}>{transaction.status}</strong></p>
                         <p><strong>Remark:</strong> <span className={`remark-${remark.toLowerCase()}`}>{remark}</span></p>
                       </div>
                     );
                   })
                ) : (
                  <table className="transactions-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Phone Number</th>
                        <th>Status</th>
                        <th>Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((transaction, index) => {
                        const remark = transaction.status === 'Completed' ? 'Successful' : transaction.status === 'Failed' ? (transaction.refunded ? 'Refunded' : 'Failed') : '';
                        return (
                          <tr key={transaction.id}>
                            <td>{moment(transaction.date).format('YYYY-MM-DD hh:mm a')}</td>
                            <td>{formatAmount(transaction.amount)} SSP</td>
                            <td>{formatPhoneNumber(transaction.phoneNumber)}</td>
                            <td><strong style={{ color: transaction.status === 'Completed' ? 'green' : transaction.status === 'Active' ? 'blue' : 'red' }}>{transaction.status}</strong></td>
                            <td className={`remark-${remark.toLowerCase()}`}>{remark}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
        </>
      )}
      {transactions.length > 0 && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Pagination
            current={pagination.currentPage}
            total={pagination.totalItems}
            pageSize={pagination.itemsPerPage}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
          <p style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
            Page {pagination.currentPage} of {pagination.totalPages} | Total: {pagination.totalItems} transactions
          </p>
        </div>
      )}
    </div>
  );
}

export default memo(TransactionsComponent);
